import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { Article } from '@/mocks/types';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  const { t } = useTranslation();

  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full h-48 overflow-hidden">
        <img
          src={article.imageUrl}
          alt={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        {article.featured && (
          <span className="absolute top-3 left-3 bg-accent-500 text-background-50 text-xs font-medium px-2 py-1 rounded-md">
            精选
          </span>
        )}
      </div>
      <div className="p-5">
        <div className="flex items-center gap-3 text-xs text-foreground-400 mb-3">
          <span className="bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full">{article.category}</span>
          <span>{article.publishedAt}</span>
          <span>{article.readTime} {t('article.minRead')}</span>
        </div>
        <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
          {article.excerpt}
        </p>
        <div className="mt-4 flex items-center gap-2 text-primary-500 text-sm font-medium">
          <span>{t('article.readMore')}</span>
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line text-sm"></i>
          </div>
        </div>
      </div>
    </Link>
  );
}